/* ==========================================================================
   BeBroot Premium — shared section behaviour (tabs, horizontal carousels)
   ========================================================================== */
(function () {
	'use strict';

	function initTabs(root) {
		if (root.dataset.bbTabs) return;
		root.dataset.bbTabs = '1';
		var tabs = Array.prototype.slice.call(root.querySelectorAll('.js-bb-tab'));
		var panels = Array.prototype.slice.call(root.querySelectorAll('.js-bb-panel'));
		if (tabs.length < 2) return;

		function activate(i, focus) {
			tabs.forEach(function (t, n) {
				var on = n === i;
				t.classList.toggle('is-active', on);
				t.setAttribute('aria-selected', on ? 'true' : 'false');
				t.tabIndex = on ? 0 : -1;
				if (on && focus) t.focus();
			});
			panels.forEach(function (p, n) {
				var on = n === i;
				p.classList.toggle('is-active', on);
				p.hidden = !on;
				if (on) {
					var track = p.querySelector('.js-bb-track-x');
					if (track) { track.scrollLeft = 0; updateArrows(track); }
				}
			});
			var active = tabs[i];
			var bar = active.parentElement;
			if (bar && bar.scrollWidth > bar.clientWidth) {
				bar.scrollTo({ left: active.offsetLeft - bar.clientWidth / 2 + active.offsetWidth / 2, behavior: 'smooth' });
			}
		}

		tabs.forEach(function (tab, i) {
			tab.addEventListener('click', function () { activate(i); });
			tab.addEventListener('keydown', function (e) {
				if (e.key === 'ArrowRight') { e.preventDefault(); activate((i + 1) % tabs.length, true); }
				if (e.key === 'ArrowLeft') { e.preventDefault(); activate((i - 1 + tabs.length) % tabs.length, true); }
			});
		});
	}

	function updateArrows(track) {
		var viewport = track.parentElement;
		if (!viewport) return;
		var prev = viewport.querySelector('.js-bb-x-prev');
		var next = viewport.querySelector('.js-bb-x-next');
		var max = track.scrollWidth - track.clientWidth;
		viewport.classList.toggle('is-scrollable', max > 4);
		if (prev) prev.disabled = track.scrollLeft <= 4;
		if (next) next.disabled = track.scrollLeft >= max - 4;
	}

	function initTrack(track) {
		if (track.dataset.bbTrack) return;
		track.dataset.bbTrack = '1';
		var viewport = track.parentElement;
		var prev = viewport && viewport.querySelector('.js-bb-x-prev');
		var next = viewport && viewport.querySelector('.js-bb-x-next');
		function page(dir) {
			track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
		}
		if (prev) prev.addEventListener('click', function () { page(-1); });
		if (next) next.addEventListener('click', function () { page(1); });
		var frame = null;
		track.addEventListener('scroll', function () {
			if (frame) cancelAnimationFrame(frame);
			frame = requestAnimationFrame(function () { updateArrows(track); });
		}, { passive: true });
		window.addEventListener('resize', function () { updateArrows(track); });
		updateArrows(track);
		if (track.closest('.bb-ptabs') || track.hasAttribute('data-bb-auto')) autoAdvance(track);
	}

	/* ---------- Product rows + reels: advance one card every few seconds (loops) ----------
	   Pauses while touched/hovered/focused, off-screen, in a hidden tab or background
	   tab, while a reel popup is open, and for a few seconds after the shopper swipes.
	   Never runs with reduced motion. data-bb-auto="<ms>" sets the pace. */
	function autoAdvance(track) {
		if (reduceMotion.matches) return;
		var DELAY = parseInt(track.getAttribute('data-bb-auto'), 10) || 3500;
		var held = false;
		var visible = false;
		var resumeAt = 0;
		var programmatic = false;

		function step() {
			if (held || !visible || document.hidden || Date.now() < resumeAt) return;
			if (track.offsetParent === null) return; // hidden tab panel
			if (document.documentElement.classList.contains('bb-lb-open')) { resumeAt = Date.now() + DELAY; return; } // reel popup covers the row
			var card = track.firstElementChild;
			if (!card) return;
			var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
			var stride = card.getBoundingClientRect().width + gap;
			var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
			programmatic = true;
			track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + stride, behavior: 'smooth' });
			setTimeout(function () { programmatic = false; }, 900);
		}

		var hold = function () { held = true; };
		var release = function () { held = false; resumeAt = Date.now() + DELAY; };
		track.addEventListener('pointerenter', hold);
		track.addEventListener('pointerleave', release);
		track.addEventListener('touchstart', hold, { passive: true });
		track.addEventListener('touchend', release, { passive: true });
		// keyboard focus only: a tapped reel gets focus back when its popup closes, which must not freeze the row
		track.addEventListener('focusin', function (e) {
			try { if (!e.target.matches(':focus-visible')) return; } catch (err) { /* no :focus-visible, hold as before */ }
			hold();
		});
		track.addEventListener('focusout', release);
		// a manual swipe or arrow click gives the shopper time before we move again
		track.addEventListener('scroll', function () { if (!programmatic) resumeAt = Date.now() + DELAY * 2; }, { passive: true });

		if ('IntersectionObserver' in window) {
			new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }, { threshold: 0.5 }).observe(track);
		} else {
			visible = true;
		}
		setInterval(step, DELAY);
	}

	/* ---------- Video stories: player is only created on tap ---------- */
	function initStories(root) {
		if (root.dataset.bbVs) return;
		root.dataset.bbVs = '1';
		var cards = Array.prototype.slice.call(root.querySelectorAll('.js-bb-vs-open'));
		var modal = root.querySelector('.js-bb-vs-modal');
		if (!cards.length || !modal) return;

		// live under <body> so no section stacking context can trap the fixed dialog
		var stale = document.getElementById(modal.id);
		if (stale && stale !== modal) stale.parentNode.removeChild(stale);
		document.body.appendChild(modal);

		var frame = modal.querySelector('.js-bb-vs-frame');
		var shop = modal.querySelector('.js-bb-vs-shop');
		var shopTitle = modal.querySelector('.js-bb-vs-shop-title');
		var shopPrice = modal.querySelector('.js-bb-vs-shop-price');
		var prev = modal.querySelector('.js-bb-vs-prev');
		var next = modal.querySelector('.js-bb-vs-next');
		var closeBtn = modal.querySelector('.bb-vs-modal__close');
		var current = 0;
		var lastFocus = null;

		function show(i) {
			current = (i + cards.length) % cards.length;
			var card = cards[current];
			var id = encodeURIComponent(card.dataset.videoId || '');
			frame.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + id +
				'?autoplay=1&playsinline=1&rel=0&modestbranding=1" title="BeBroot video" ' +
				'allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
			if (card.dataset.productUrl) {
				shop.href = card.dataset.productUrl;
				shopTitle.textContent = card.dataset.productTitle || '';
				shopPrice.textContent = card.dataset.productPrice || '';
				shop.hidden = false;
			} else {
				shop.hidden = true;
			}
			prev.hidden = next.hidden = cards.length < 2;
		}
		function onKey(e) {
			if (e.key === 'Escape') close();
			else if (e.key === 'ArrowRight') show(current + 1);
			else if (e.key === 'ArrowLeft') show(current - 1);
		}
		function open(i) {
			lastFocus = document.activeElement;
			modal.hidden = false;
			document.documentElement.classList.add('bb-lock');
			show(i);
			document.addEventListener('keydown', onKey);
			if (closeBtn) closeBtn.focus();
		}
		function close() {
			modal.hidden = true;
			frame.innerHTML = '';
			document.documentElement.classList.remove('bb-lock');
			document.removeEventListener('keydown', onKey);
			if (lastFocus && lastFocus.focus) lastFocus.focus();
		}

		cards.forEach(function (card, i) {
			card.addEventListener('click', function () { open(i); });
		});
		modal.addEventListener('click', function (e) {
			if (e.target.closest('.js-bb-vs-close')) close();
		});
		prev.addEventListener('click', function () { show(current - 1); });
		next.addEventListener('click', function () { show(current + 1); });
	}

	/* ---------- Concern chips: bring the active chip into view ---------- */
	function initChips(list) {
		if (list.dataset.bbChips) return;
		list.dataset.bbChips = '1';
		var active = list.querySelector('.is-active');
		if (!active) return;
		function center() {
			if (list.scrollWidth <= list.clientWidth) return;
			var l = list.getBoundingClientRect();
			var a = active.getBoundingClientRect();
			list.scrollLeft += (a.left - l.left) - (l.width - a.width) / 2;
		}
		center();
		// chip widths change once the web font arrives
		if (document.fonts && document.fonts.ready) document.fonts.ready.then(center);
	}

	/* ---------- Tap to copy a discount code ---------- */
	document.addEventListener('click', function (e) {
		var btn = e.target.closest && e.target.closest('.js-bb-copy-code');
		if (!btn) return;
		var code = btn.dataset.code || '';
		var label = btn.querySelector('.js-bb-copy-label');
		var original = label ? label.textContent : '';
		var done = function () {
			btn.classList.add('is-copied');
			if (label) label.textContent = 'Copied!';
			setTimeout(function () {
				btn.classList.remove('is-copied');
				if (label) label.textContent = original;
			}, 2200);
		};
		if (navigator.clipboard && navigator.clipboard.writeText) {
			navigator.clipboard.writeText(code).then(done, done);
		} else {
			var ta = document.createElement('textarea');
			ta.value = code;
			ta.setAttribute('readonly', '');
			ta.style.position = 'fixed';
			ta.style.opacity = '0';
			document.body.appendChild(ta);
			ta.select();
			try { document.execCommand('copy'); } catch (err) {}
			document.body.removeChild(ta);
			done();
		}
	});

	/* ---------- Cart drawer upsell: one-tap add through the theme cart ---------- */
	document.addEventListener('click', function (e) {
		var btn = e.target.closest && e.target.closest('.js-bb-cu-add');
		if (!btn) return;
		e.preventDefault();
		var id = parseInt(btn.dataset.variantId, 10);
		if (!id || btn.classList.contains('is-loading')) return;
		var label = btn.querySelector('.bb-cu__add-label');
		btn.classList.add('is-loading');
		if (label) label.textContent = 'Adding';
		var reset = function () {
			btn.classList.remove('is-loading');
			if (label) label.textContent = '+ Add';
		};
		var core = window.themeCore;
		if (core && core.CartApi && core.CartApi.makeRequest) {
			Promise.resolve(core.CartApi.makeRequest(core.CartApi.actions.ADD_TO_CART, { id: id, quantity: 1 }))
				.then(function () { return core.CartApi.makeRequest(core.CartApi.actions.GET_CART); })
				.catch(function () {})
				.then(reset);
		} else {
			var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
			fetch(root + 'cart/add.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
				body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
			}).then(function () { window.location.href = root + 'cart'; }, reset);
		}
	});

	/* ---------- One-tap add (ritual kit, add-ons): Adding… → Added ✓ → reset ---------- */
	document.addEventListener('click', function (e) {
		var btn = e.target.closest && e.target.closest('.js-bb-add');
		if (!btn) return;
		e.preventDefault();
		var id = parseInt(btn.dataset.variantId, 10);
		var qty = parseInt(btn.dataset.quantity, 10) || 1;
		if (!id || btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
		var label = btn.querySelector('.js-bb-add-label');
		var original = label ? label.textContent : '';
		btn.classList.add('is-loading');
		btn.setAttribute('aria-busy', 'true');
		if (label) label.textContent = 'Adding…';

		var finish = function (ok) {
			btn.classList.remove('is-loading');
			btn.removeAttribute('aria-busy');
			if (ok) {
				btn.classList.add('is-added');
				if (label) label.textContent = label.dataset.added || 'Added';
				setTimeout(function () {
					btn.classList.remove('is-added');
					if (label) label.textContent = original;
				}, 2400);
			} else if (label) {
				label.textContent = original;
			}
		};

		var core = window.themeCore;
		if (core && core.CartApi && core.CartApi.makeRequest) {
			Promise.resolve(core.CartApi.makeRequest(core.CartApi.actions.ADD_TO_CART, { id: id, quantity: qty }))
				.then(function () { return core.CartApi.makeRequest(core.CartApi.actions.GET_CART); })
				.then(function () { finish(true); }, function () { finish(false); });
		} else {
			var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
			fetch(root + 'cart/add.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
				body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
			}).then(function (r) {
				if (!r.ok) throw new Error('add failed');
				window.location.href = root + 'cart';
			}).catch(function () { finish(false); });
		}
	});

	/* ---------- Hero: cross-fade slides, story-style progress bars ---------- */
	var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

	function initHero(root) {
		if (root.dataset.bbInit) return;
		root.dataset.bbInit = '1';
		var slides = Array.prototype.slice.call(root.querySelectorAll('.bb-hero__slide'));
		var dots = Array.prototype.slice.call(root.querySelectorAll('.js-bb-hero-dot'));
		var pauseBtn = root.querySelector('.js-bb-hero-pause');
		if (slides.length < 2) return;

		var index = 0;
		var userPaused = false;
		var hoverPaused = false;
		var offscreen = false;
		var autoplay = root.dataset.autoplay === 'true' && !reduceMotion.matches;
		if (!autoplay) root.classList.add('is-static');

		function syncPaused() {
			var paused = !autoplay || userPaused || hoverPaused || offscreen || document.hidden;
			root.classList.toggle('is-paused', paused);
		}

		function goTo(i) {
			index = (i + slides.length) % slides.length;
			slides.forEach(function (s, n) {
				var on = n === index;
				s.classList.toggle('is-active', on);
				if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
				s.querySelectorAll('a').forEach(function (a) { if (on) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); });
			});
			dots.forEach(function (d, n) {
				d.classList.toggle('is-active', n === index);
				d.classList.toggle('is-done', n < index);
				d.setAttribute('aria-selected', n === index ? 'true' : 'false');
				// restart the fill animation on the active bar
				var fill = d.querySelector('.bb-hero__bar-fill');
				if (fill && n === index) { fill.style.animation = 'none'; void fill.offsetWidth; fill.style.animation = ''; }
			});
		}

		dots.forEach(function (d, n) {
			d.addEventListener('click', function () { goTo(n); });
			var fill = d.querySelector('.bb-hero__bar-fill');
			if (fill) fill.addEventListener('animationend', function () {
				if (n === index && autoplay) goTo(index + 1);
			});
		});

		if (pauseBtn) {
			if (!autoplay) pauseBtn.hidden = true;
			pauseBtn.addEventListener('click', function () {
				userPaused = !userPaused;
				pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
				pauseBtn.setAttribute('aria-label', userPaused ? 'Play slides' : 'Pause slides');
				syncPaused();
			});
		}

		// pause while the pointer or keyboard focus is on the hero
		root.addEventListener('mouseenter', function () { hoverPaused = true; syncPaused(); });
		root.addEventListener('mouseleave', function () { hoverPaused = false; syncPaused(); });
		root.addEventListener('focusin', function () { hoverPaused = true; syncPaused(); });
		root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) { hoverPaused = false; syncPaused(); } });

		// swipe
		var startX = null, startY = null;
		root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; startY = e.touches[0].clientY; }, { passive: true });
		root.addEventListener('touchend', function (e) {
			if (startX === null) return;
			var dx = e.changedTouches[0].clientX - startX;
			var dy = e.changedTouches[0].clientY - startY;
			if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) goTo(index + (dx < 0 ? 1 : -1));
			startX = startY = null;
		}, { passive: true });

		// arrow keys when focus is inside the hero
		root.addEventListener('keydown', function (e) {
			if (e.key === 'ArrowRight') { goTo(index + 1); }
			else if (e.key === 'ArrowLeft') { goTo(index - 1); }
		});

		// don't run while off-screen or in a background tab
		if ('IntersectionObserver' in window) {
			new IntersectionObserver(function (entries) {
				offscreen = !entries[0].isIntersecting;
				syncPaused();
			}, { threshold: 0.25 }).observe(root);
		}
		document.addEventListener('visibilitychange', syncPaused);

		goTo(0);
		syncPaused();
	}

	/* "View all ingredients" sheet (sections/bb-ingredients.liquid) */
	function initIngredients(root) {
		if (root.dataset.bbIng) return;
		root.dataset.bbIng = '1';
		var trigger = root.querySelector('.js-bb-ing-open');
		var dialog = root.querySelector('.js-bb-ing-dialog');
		if (!trigger || !dialog) return;

		function unlock() { document.documentElement.classList.remove('bb-lock'); }
		function close() {
			if (typeof dialog.close === 'function') dialog.close();
			else dialog.removeAttribute('open');
			unlock();
		}

		trigger.addEventListener('click', function () {
			if (typeof dialog.showModal === 'function') dialog.showModal();
			else dialog.setAttribute('open', '');
			document.documentElement.classList.add('bb-lock');
			var body = dialog.querySelector('.bb-ing-all__body');
			if (body) body.scrollTop = 0;
		});
		dialog.querySelector('.js-bb-ing-close').addEventListener('click', close);
		dialog.addEventListener('close', unlock);
		/* a tap on the dimmed backdrop lands on the dialog element itself */
		dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
	}

	/* Ingredient circles: a silent loop over the photo, fetched and played only while on screen.
	   Reduced motion, Data Saver or a blocked autoplay (iOS Low Power) keep the photo. */
	function initIngVideo(video) {
		if (video.dataset.bbInit) return;
		video.dataset.bbInit = '1';
		var saveData = navigator.connection && navigator.connection.saveData;
		if (reduceMotion.matches || saveData || !('IntersectionObserver' in window)) return;
		video.muted = true;
		video.addEventListener('playing', function () { video.classList.add('is-playing'); });
		new IntersectionObserver(function (entries) {
			if (entries[0].isIntersecting) {
				if (!video.getAttribute('src')) video.src = video.dataset.src;
				var p = video.play();
				if (p && p.catch) p.catch(function () {});
			} else if (!video.paused) {
				video.pause();
			}
		}, { threshold: 0.25 }).observe(video);
	}

	/* Festive sale tags (bb-sale-tag): Liquid checks the dates too, this catches a cached page
	   served after the sale ends. Days are compared in India time. */
	function initSaleTag(el) {
		var today = parseInt(new Date(Date.now() + 330 * 60000).toISOString().slice(0, 10).replace(/-/g, ''), 10);
		var start = parseInt(el.dataset.start, 10) || 0;
		var end = parseInt(el.dataset.end, 10) || 0;
		if (!((start && today < start) || (end && today > end))) return;
		/* the card's Add 2 quantity goes back to its normal minimum, not away */
		if (el.dataset.base) {
			el.value = el.dataset.base;
			return;
		}
		el.remove();
	}

	function boot(scope) {
		scope = scope || document;
		scope.querySelectorAll('.js-bb-sale').forEach(initSaleTag);
		scope.querySelectorAll('.js-bb-ingredients').forEach(initIngredients);
		scope.querySelectorAll('.js-bb-ing-vid').forEach(initIngVideo);
		scope.querySelectorAll('.js-bb-hero').forEach(initHero);
		scope.querySelectorAll('.js-bb-tabs').forEach(initTabs);
		scope.querySelectorAll('.js-bb-track-x').forEach(initTrack);
		scope.querySelectorAll('.js-bb-vs').forEach(initStories);
		scope.querySelectorAll('.js-bb-cnav').forEach(initChips);
	}

	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
	else boot();

	document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
	document.addEventListener('shopify:block:select', function (e) {
		var tab = e.target.closest && e.target.closest('.js-bb-tab');
		if (tab) tab.click();
	});
})();
